import { UtilService } from './../../../services/util.service';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { CommonService } from '../../../services/common/common.service';
import { Observable, Subject, of, from } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
  catchError,
  takeUntil,
  finalize,
} from 'rxjs/operators';
import { Articulo, ArticulosResponse } from '../model-claves-genericas/model-claves-genericas';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-modal-claves-genericas',
  templateUrl: './modal-claves-genericas.component.html',
  styleUrls: ['./modal-claves-genericas.component.scss'],
})
export class ModalClavesGenericasComponent implements OnInit, OnDestroy {
  public formGroup: FormGroup;
  public productCtrl: FormControl = new FormControl('', Validators.required);
  public filteredOptions!: Observable<Articulo[]>;
  public isLoading = true; // <-- indicador de carga
  private unsubscribe$ = new Subject<void>();
  public path: string = environment.apiImage + (environment.empresaId == 1 ? '/Kabik/imagenes_fichas/' : '/Letech/imagenes_fichas/');

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ModalClavesGenericasComponent>,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private UtilService: UtilService
  ) {
    this.formGroup = this.formBuilder.group({
      NumeroParte: ['', [Validators.required]],
      Clave: ['', [Validators.required]],
      Descripcion: ['', [Validators.required]],
      CostoCompra: ['', [Validators.required]],
      MonedaCompra: ['', [Validators.required]],
      ClaveInterna: [''],
      WsinventarioId: [''],
    });
  }

  ngOnInit(): void {
    this.filteredOptions = this.productCtrl.valueChanges.pipe(
      takeUntil(this.unsubscribe$),
      debounceTime(300),
      distinctUntilChanged(),

      tap((value) => {
        if (value && value.length >= 1) {
          this.isLoading = true;
        } else {
          this.isLoading = false;
        }
      }),

      switchMap((term: string) => {
        if (term && term.length >= 1) {
          return from(this.commonService.searchProduct(term)).pipe(
            switchMap((res: ArticulosResponse) => {
              if (res.estatus && Array.isArray(res.respuesta)) {
                return of(res.respuesta);
              } else {
                return of([]);
              }
            }),
            catchError(() => of([])),
            finalize(() => {
              this.isLoading = false;
            })
          );
        } else {
          this.isLoading = false;
          return of([]);
        }
      }),
      catchError(() => {
        this.isLoading = false;
        return of([]);
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onSelectOption(option: Articulo) {
    this.formGroup.patchValue({ WsinventarioId: option.WsInventarioID });
    this.formGroup.patchValue({ Descripcion: option.DescripcionArticulo });
    this.formGroup.patchValue({ NumeroParte: option.ClaveArticuloProveedor });
    this.formGroup.patchValue({ Clave: option.ClaveArticuloMayorista });
    this.validateKey(option.ClaveArticuloMayorista);
    this.validatePartNumber(option.ClaveArticuloProveedor);
  }

  modalClose(): void {
    this.matDialogRef.close(false);
  }

  onSubmit() {
    if (this.formGroup.invalid) {
      /* Swal.fire({
        type: 'warning',
        title: 'Faltan campos por completar',
        text: 'Por favor, escribe los datos que faltan',
        confirmButtonText: 'Aceptar',
      }); */
      return;
    }
    this.insert();
  }

  insert() {
    Swal.fire({
      title: 'Guardando...',
      text: 'Por favor espere',
      allowOutsideClick: false,
    });
    Swal.showLoading();
    this.commonService
      .createGenericKey(
        this.formGroup.value.Clave,
        this.formGroup.value.NumeroParte,
        this.formGroup.value.Descripcion,
        this.formGroup.value.MonedaCompra,
        0,
        this.formGroup.value.CostoCompra
      )
      .then((res) => {
        if (res.message === 'true') {
          Swal.fire({
            type: 'success',
            title: '¡Correcto!',
            text: 'Se ha guardado correctamente',
            allowOutsideClick: false,
            confirmButtonText: 'Aceptar',
          }).then((res) => {
            if (res.value) {
              this.matDialogRef.close(true);
            }
          });
        } else {
          throw new Error(
            'Hubo un error al insertar en la base de datos, contacte al administrador'
          );
        }
      })
      .catch((error) => {
           Swal.fire({
             type: 'error',
             title: 'Error',
             text: error.message,
           });
      });
  }

  validateKey(key: string) {
    if (key) {
      this.commonService
        .validateGenericKey('clave', key)
        .then((res) => {
          if (res.message === 'false') {
            Swal.fire({
              type: 'warning',
              title: 'Atención',
              text: 'La clave: ' + key + ' ya existe',
              confirmButtonText: 'Aceptar',
            }).then((r) => {
              if (r.value) {
                this.formGroup.controls.Clave.setValue('');
                this.clearForm();
              }
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            type: 'error',
            title: 'Error',
            text: error.message,
          });
        });
    }
  }

  validatePartNumber(part_number: string) {
    if (part_number) {
      this.commonService
        .validateNoParte('noParte', part_number)
        .then((res) => {
          if (res.message === 'false') {
            Swal.fire({
              type: 'warning',
              title: 'Atención',
              text: 'El número de parte: ' + part_number + ' ya existe',
              confirmButtonText: 'Aceptar',
            }).then((r) => {
              if (r.value) {
                this.formGroup.controls.NumeroParte.setValue('');
                this.clearForm();
              }
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            type: 'error',
            title: 'Error',
            text: error.message,
          });
        });
    }
  }

  validateProduct(product: string) {
    console.log(product);
    console.log(this.filteredOptions);

    this.commonService.searchProduct(product).then((res) => {
      console.log(res);
    });
  }

  replace(data: string) {
    return this.UtilService.replaceAllByArrayString(
      ['/', '#', '%', '?', '[', ']', "'", ' ', '<', '>'],
      data,
      '_'
    );
  }
  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = '../../../../../../assets/not_found_image.png';
  }

  clearForm() {
    this.formGroup.reset();
    this.productCtrl.reset();
    //this.filteredOptions = of([]);
    //this.isLoading = false;
  }
}
